var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_380_7686)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_380_7686)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9414 0C25.778 0 32.9414 7.16344 32.9414 16C32.9414 24.8366 25.778 32 16.9414 32C8.10485 32 0.941406 24.8366 0.941406 16C0.941406 7.16344 8.10485 0 16.9414 0Z",
    fill: "#5C94F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.2693 22.7385L26.0027 12.4575C26.3672 12.1083 26.3672 11.5423 26.0027 11.1931L24.6828 9.92883C24.3183 9.57971 23.7273 9.57971 23.3628 9.92883L14.6094 18.3134L10.5226 14.3988C10.1581 14.0497 9.56712 14.0497 9.20264 14.3988L7.88273 15.6631C7.51826 16.0123 7.51826 16.5783 7.88273 16.9275L13.9494 22.7385C14.3139 23.0876 14.9048 23.0876 15.2693 22.7385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_380_7686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.941406)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_380_7686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.941406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.35cae938c27c46b9c20071a3bb4e8457.svg";
export { ForwardRef as ReactComponent };